import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useConfig } from './ConfigContext';

export const ReCaptchaWrapper = ({ children }) => {
  const { recaptchaSiteKey } = useConfig();

  if (!recaptchaSiteKey) {
    return children;
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
      {children}
    </GoogleReCaptchaProvider>
  );
};
